import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarContext } from './main-sidebar';

// SidebarItem Component
function SidebarItem({ icon, text, href, alert = false }) {
  const { expanded } = useContext(SidebarContext); // Use SidebarContext for expanded state

  return (
    <NavLink
      to={href}
      className={({ isActive }) =>
        `flex items-center relative py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group ${
          isActive
            ? 'bg-gradient-to-tr from-indigo-200 to-indigo-100 text-indigo-800'
            : 'hover:bg-gray-200 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-400'
        }`
      }
    >
      {/* Icon */}
      {icon}

      {/* Text with transition based on expanded state */}
      <span
        className={`overflow-hidden transition-all duration-300 text-lg ${
          expanded ? 'w-52 ml-3 opacity-100' : 'w-0 opacity-0'
        }`}
      >
        {text}
      </span>

      {/* Alert Indicator */}
      {alert && (
        <div
          className={`absolute right-2 w-2 h-2 rounded-full bg-indigo-400 ${
            expanded ? '' : 'top-2'
          }`}
        />
      )}

      {/* Tooltip for when sidebar is collapsed */}
      {!expanded && (
        <div
          className={`
            absolute left-full rounded-md px-2 py-1 ml-6 bg-indigo-100 text-indigo-800 text-sm invisible opacity-0
            translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 z-50
          `}
        >
          {text}
        </div>
      )}
    </NavLink>
  );
}

export default SidebarItem;
